const targetEndTime = new Date('2023-11-18T11:00:00-08:00').getTime();

    function updateCountdown() {
      const currentTime = new Date().getTime();
      const timeDifference = targetEndTime - currentTime;

      // Check if the countdown has ended
      if (timeDifference <= 0) {
        document.getElementById('countdown').style.display = 'none';
        document.getElementById('explosion').style.display = 'block';
        // Add explosion animation or any other effects here
        return;
      }

      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      document.getElementById('countdown').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

      setTimeout(updateCountdown, 1000);
    }

function redirectUser() {
      window.location.href = 'https://your-destination-url.com'; // Replace with your actual destination URL
    }

    updateCountdown();